import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=98cd9a9c&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd9a9c",
  null
  
)

export default component.exports